// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Z6qXj2E4xTm8VTgwXtOE{color:#5e8eb7}`, "",{"version":3,"sources":["webpack://./Scripts/app/components/iniciar-orcamento/iniciar-orcamento.module.scss"],"names":[],"mappings":"AAAA,sBACI,aAAA","sourcesContent":[".legenda {\r\n    color: #5e8eb7;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legenda": `Z6qXj2E4xTm8VTgwXtOE`
};
export default ___CSS_LOADER_EXPORT___;
